export class Template {
    static getById(templateId: string) {
        return $(`[data-template-id="${$.escapeSelector(templateId)}"]`).clone().removeAttr("data-template-id")[0];
    }
}